// @flow

function updateCommentCount(id: string, increment: boolean) {
  return {
    type: 'UPDATE_ACTIVITY_ITEM_COMMENT_COUNT',
    payload: { increment, id },
  };
}

export function decrementCommentCount(id: string) {
  return updateCommentCount(id, false);
}

export function incrementCommentCount(id: string) {
  return updateCommentCount(id, true);
}

export default undefined;
